export default __webpack_public_path__ + "static/media/accordianBtn.90a19421.svg";